import config from "config";

export const LOGO_URL = config.publicS3Url + "/logo";
